import React, {Component} from 'react';
import * as func from "../../../../../../utils/functions";
import {EDIT_MODE, MESSAGE} from "../../../../../../wpconfig";

class MPIntroduceCarrerItem extends Component {
	constructor(props) {
		super(props);

		const r = func.deepClone(this.props.record);

		this.state = {
			isEdit: r.is_edit ? EDIT_MODE.SHOW_EDIT : EDIT_MODE.SHOW,
			record: r,
		}
	}

	onEditSave = (event) => {
		event.preventDefault()

		let isEdit = '';
		if (this.state.isEdit === EDIT_MODE.SHOW) {
			isEdit = EDIT_MODE.SHOW_EDIT;
		} else if (this.state.isEdit === EDIT_MODE.SHOW_EDIT) {
			isEdit = EDIT_MODE.SAVE_EDIT;
		}

		const {record} = this.props

		if (isEdit === EDIT_MODE.SAVE_EDIT) {
			if (record.scholar_career_id) {
				func.updateData("my_library/career/update", record).then((response) => {
					if (response.code === 'ok') {
						isEdit = EDIT_MODE.SHOW;
						this.setState({
							'isEdit': isEdit,
							record: func.deepClone(record)
						})
						// this.props.showMessage('수정 되었습니다.');
					} else {
						// this.props.showMessage('수정 실패 : ' + response.message)
						isEdit = EDIT_MODE.SHOW_EDIT;
					}
				});
			} else {
				if (this.career_kind.value === '') {
					this.career_kind.focus();
				} else {
					delete record.is_edit;
					func.updateData("my_library/career/insert", record).then((response) => {
						if (response.code === 'ok') {
							this.setState({'isEdit': EDIT_MODE.SHOW});
							record[this.props.pkKey] = response[this.props.pkKey];
							this.props.onUpdate(this.props.arrIndex, record, true);
							// this.props.showMessage('추가 되었습니다.');
						} else {
							// this.props.showMessage('저장 실패 : ' + response.message);
							// isEdit = EDIT_MODE.SHOW_EDIT;
						}
					});
				}
			}
		} else {
			this.props.onEditIndex(this.props.index)
			this.setState({'isEdit': EDIT_MODE.SHOW_EDIT});
		}
	}

	onCloseDelete = (event) => {
		event.preventDefault()
		if (this.props.record.scholar_career_id) {
			if (this.state.isEdit) {
				Object.keys(this.state.record).map((key) => {
					if (this[key]) {
						this[key].value = this.state.record[key]
					}
				});
				this.props.onUpdate(this.props.arrIndex, this.state.record, true);
				this.setState({'isEdit': EDIT_MODE.SHOW});
			} else {
				if (confirm('경력 : ' + this.props.record.career_org + '(' + this.props.record.career_role + ')을(를) ' + MESSAGE.DELETE)) {
					func.updateData("my_library/career/delete", this.props.record).then((response) => {
						if (response.code === 'ok') {
							// this.props.showMessage('삭제 되었습니다.');
							this.props.onRemove(this.props.arrIndex)
						} else {
							// this.props.showMessage('삭제 실패 : ' + response.message)
						}
					});
				}
			}
		} else {
			this.setState({'isEdit': EDIT_MODE.SHOW});
			this.props.onRemove(this.props.index)
		}
	}

	onClose = (e) => {
		this.setState({'isEdit': EDIT_MODE.SHOW});
		if (this.props.record[this.props.pkKey]) {
			this.props.onUpdate(this.props.arrIndex, this.state.record);
		} else {
			this.props.onRemove(this.props.arrIndex)
		}
	}

	textEvent = (event) => {
		let record = this.props.record;
		record[event.target.name] = event.target.value;
		this.props.onUpdate(this.props.arrIndex, this.props.record, false);
	}

	checked = () => {
		const record = this.props.record;
		if (event.target.checked) {
			record[event.target.name] = 'Y';
		} else {
			record[event.target.name] = 'N';
		}
		this.props.onUpdate(this.props.arrIndex, record, true);
	}

	render() {
		const {record} = this.props

		return (
			<>
				{
					this.state.isEdit === EDIT_MODE.SHOW ?
						<div className={"d-flex align-items-center" + (this.props.arrIndex > 0 ? ' pt-2' : '')}>
							<div className="d-flex">
								<input type="text" className="form-control mr-2" placeholder="시작일"
								       style={{width: "100px"}}
								       name="start_yyyymm"
								       ref={(ref) => this.start_yyyymm = ref}
								       value={record.start_yyyymm || ""}
								       onChange={this.textEvent}
								       readOnly={true}/>
								<input type="text" className="form-control mr-2" placeholder="종료일"
								       name="end_yyyymm"
								       style={{width: "100px"}}
								       ref={(ref) => this.end_yyyymm = ref}
								       value={record.end_yyyymm || ""}
								       onChange={this.textEvent}
								       readOnly={true}/>
								<select className="form-control form-control-sm pr-2 mr-2"
								        defaultValue={record.career_kind}
								        ref={(ref) => this.career_kind = ref}
								        name="career_kind"
								        onChange={this.textEvent}
								        disabled={true}>
									{this.props.scholar_kind.map((type, i) => {
										return (<option key={type.code_id} value={type.code_id}>{type.code_name}</option>)
									})}
								</select>
								<input type="text" className="form-control mr-2" placeholder="수여기관"
								       name="career_org"
								       ref={(ref) => this.career_org = ref}
								       value={record.career_org || ""}
								       onChange={this.textEvent}
								       readOnly={true}/>
								<input type="text" className="form-control mr-2" placeholder="역할"
								       name="career_role"
								       ref={(ref) => this.career_role = ref}
								       value={record.career_role || ""}
								       onChange={this.textEvent}
								       readOnly={true}/>
							</div>
							<div style={{width: '100px'}}>
								{record[this.props.pkKey] ?
									<button className="btn btn-outline-info btn-sm insert mr-1" onClick={this.onEditSave}>수정</button>
									:
									<button className="btn btn-outline-info btn-sm insert mr-1" onClick={this.onEditSave}>저장</button>
								}
								<button className="btn btn-outline-dark btn-sm cancel" onClick={this.onCloseDelete}>삭제</button>
							</div>
						</div>
						:
						<div className={"d-flex align-items-center" + (this.props.arrIndex > 0 ? ' pt-2' : '')}>
							<div className="d-flex">
								<input type="text" className="form-control mr-2" placeholder="시작일"
								       style={{width: "100px"}}
								       name="start_yyyymm"
								       ref={(ref) => this.start_yyyymm = ref}
								       value={record.start_yyyymm || ""}
								       onChange={this.textEvent} />
								<input type="text" className="form-control mr-2" placeholder="종료일"
								       name="end_yyyymm"
								       style={{width: "100px"}}
								       ref={(ref) => this.end_yyyymm = ref}
								       value={record.end_yyyymm || ""}
								       onChange={this.textEvent} />
								<select className="form-control form-control-sm pr-2 mr-2"
								        defaultValue={record.career_kind}
								        ref={(ref) => this.career_kind = ref}
								        name="career_kind"
								        onChange={this.textEvent} >
									{this.props.scholar_kind.map((type, i) => {
										return (<option key={type.code_id} value={type.code_id}>{type.code_name}</option>)
									})}
								</select>
								<input type="text" className="form-control mr-2" placeholder="수여기관"
								       name="career_org"
								       ref={(ref) => this.career_org = ref}
								       value={record.career_org || ""}
								       onChange={this.textEvent} />
								<input type="text" className="form-control mr-2" placeholder="역할"
								       name="career_role"
								       ref={(ref) => this.career_role = ref}
								       value={record.career_role || ""}
								       onChange={this.textEvent} />
							</div>
							<div style={{width: '100px'}}>
								{record[this.props.pkKey] ?
									<button className="btn btn-outline-info btn-sm insert mr-1" onClick={this.onEditSave}>수정</button>
									:
									<button className="btn btn-outline-info btn-sm insert mr-1" onClick={this.onEditSave}>저장</button>
								}
								<button className="btn btn-outline-dark btn-sm cancel" onClick={this.onCloseDelete}>닫기</button>
							</div>
						</div>
				}
			</>
		)
	}
}

export default MPIntroduceCarrerItem;
